// // inspectionDB.js
// import { openDB } from 'idb';
// import formCreationService from '../formconfiguration.service';

// // Simplified IndexedDB Helper Class
// class InspectionDB {
//     constructor() {
//         this.dbName = 'InspectionDB';
//         this.version = 5; // Increment version for schema changes
//         this.db = null;
//         this.storageQuota = null;
//         this.usedStorage = 0;
//     }

//     async initDB() {
//         if (this.db) return this.db;

//         this.db = await openDB(this.dbName, this.version, {
//             upgrade(db, oldVersion, newVersion, transaction) {
//                 // Single inspections store (stores ALL data including images)
//                 if (!db.objectStoreNames.contains('inspections')) {
//                     const inspectionStore = db.createObjectStore('inspections', {
//                         keyPath: 'id',
//                         autoIncrement: true
//                     });

//                     // Create indexes for efficient querying
//                     inspectionStore.createIndex('dateTime', 'dateTime');
//                     inspectionStore.createIndex('eventType', 'eventType');
//                     inspectionStore.createIndex('reportType', 'reportType');
//                     inspectionStore.createIndex('imo_number', 'imo_number');
//                     inspectionStore.createIndex('composite', ['eventType', 'dateTime', 'imo_number']);
//                     inspectionStore.createIndex('compositeWithReport', ['eventType', 'reportType', 'dateTime', 'imo_number']);
//                 } else {
//                     // Handle upgrades for existing inspections store
//                     const inspectionStore = transaction.objectStore('inspections');

//                     // Add reportType index if it doesn't exist
//                     if (!inspectionStore.indexNames.contains('reportType')) {
//                         inspectionStore.createIndex('reportType', 'reportType');
//                     }

//                     // Add compositeWithReport index if it doesn't exist
//                     if (!inspectionStore.indexNames.contains('compositeWithReport')) {
//                         inspectionStore.createIndex('compositeWithReport', ['eventType', 'reportType', 'dateTime', 'imo_number']);
//                     }
//                 }

//                 if (!db.objectStoreNames.contains('formConfigurations')) {
//                     const formConfigStore = db.createObjectStore('formConfigurations', {
//                         keyPath: ['eventType', 'reportType'] // Composite key with eventType and reportType
//                     });

//                     // Create indexes for efficient querying
//                     formConfigStore.createIndex('eventType', 'eventType');
//                     formConfigStore.createIndex('reportType', 'reportType');
//                     formConfigStore.createIndex('lastUpdated', 'lastUpdated');
//                     formConfigStore.createIndex('synced', 'synced', { unique: false });
//                     formConfigStore.createIndex('status', 'status', { unique: false });
//                 } else if (oldVersion < 5) {
//                     // Handle upgrade for formConfigurations store
//                     const formConfigStore = transaction.objectStore('formConfigurations');

//                     // Add reportType index if it doesn't exist
//                     if (!formConfigStore.indexNames.contains('reportType')) {
//                         formConfigStore.createIndex('reportType', 'reportType');
//                     }
//                 }

//                 if (!db.objectStoreNames.contains('ships')) {
//                     const shipStore = db.createObjectStore('ships', {
//                         keyPath: 'id',
//                         autoIncrement: true
//                     });

//                     // Create indexes
//                     shipStore.createIndex('user_id', 'user_id', { unique: false });
//                     shipStore.createIndex('imo_number', 'imo_number', { unique: false });
//                     shipStore.createIndex('server_id', 'server_id', { unique: false });
//                     shipStore.createIndex('synced', 'synced', { unique: false });
//                 } else if (oldVersion < 2) {
//                     // Add synced index if upgrading from version 1
//                     const shipStore = transaction.objectStore('ships');
//                     if (!shipStore.indexNames.contains('synced')) {
//                         shipStore.createIndex('synced', 'synced', { unique: false });
//                     }
//                 }
//             }
//         });

//         // Initialize storage info
//         await this.updateStorageInfo();
//         return this.db;
//     }


//     // Main createInspection method - stores everything in one table
//     async createInspection(payload, onProgress = null) {
//         if (!this.db) await this.initDB();

//         let inspectionData, eventType, reportType, dateTime, imo_number, timestamp;

//         if (typeof payload === 'object' && payload.data && payload.eventType) {
//             ({ data: inspectionData, eventType, reportType, dateTime, imo_number, timestamp } = payload);
//         } else {
//             [inspectionData, eventType, reportType, dateTime, imo_number] = arguments;
//         }

//         try {
//             // Check storage before processing
//             await this.updateStorageInfo();
//             const estimatedSize = await this.estimatePayloadSize(inspectionData);

//             if (!await this.checkStorageCapacity(estimatedSize)) {
//                 throw new Error(`Insufficient storage. Need: ${this.formatBytes(estimatedSize)}, Available: ${this.formatBytes(this.getAvailableStorage())}`);
//             }

//             if (onProgress) onProgress({ stage: 'preprocessing', progress: 20 });

//             // Process images to ensure proper format
//             const processedData = this.processImageData(inspectionData);

//             if (onProgress) onProgress({ stage: 'storing_data', progress: 60 });

//             // Store inspection with all data in single record
//             const tx = this.db.transaction('inspections', 'readwrite');
//             const inspection = {
//                 eventType,
//                 reportType: reportType || null, // Allow null reportType for backward compatibility
//                 dateTime,
//                 imo_number,
//                 data: processedData, // Store complete data including images
//                 createdAt: new Date().toISOString(),
//                 imageCount: this.countImages(processedData)
//             };

//             const inspectionResult = await tx.objectStore('inspections').add(inspection);
//             const inspectionId = inspectionResult;
//             await tx.done;

//             if (onProgress) onProgress({ stage: 'complete', progress: 100 });

//             // Update storage info after successful creation
//             await this.updateStorageInfo();

//             return {
//                 inspectionId,
//                 imageCount: inspection.imageCount,
//                 storageInfo: await this.getStorageInfo()
//             };

//         } catch (error) {
//             console.error('Error creating inspection:', error);
//             throw error;
//         }
//     }

//     // Process image data to ensure proper format (no compression)
//     processImageData(inspectionData) {
//         const processedData = JSON.parse(JSON.stringify(inspectionData));

//         for (const step of processedData) {
//             // Process common images
//             if (step.common_data && step.common_data.images) {
//                 for (const image of step.common_data.images) {
//                     if (image.image_url && typeof image.image_url === 'string') {
//                         // Ensure it's a proper data URL
//                         if (!image.image_url.startsWith('data:')) {
//                             image.image_url = `data:image/png;base64,${image.image_url}`;
//                         }
//                     }
//                 }
//             }

//             // Process unit images
//             for (const unit of step.units) {
//                 if (unit.images) {
//                     for (const image of unit.images) {
//                         if (image.image_url && typeof image.image_url === 'string') {
//                             // Ensure it's a proper data URL
//                             if (!image.image_url.startsWith('data:')) {
//                                 image.image_url = `data:image/png;base64,${image.image_url}`;
//                             }
//                         }
//                     }
//                 }
//             }
//         }

//         return processedData;
//     }

//     // Count total images in inspection data
//     countImages(inspectionData) {
//         let count = 0;

//         for (const step of inspectionData) {
//             // Count common images
//             if (step.common_data && step.common_data.images) {
//                 count += step.common_data.images.length;
//             }

//             // Count unit images
//             for (const unit of step.units) {
//                 if (unit.images) {
//                     count += unit.images.length;
//                 }
//             }
//         }

//         return count;
//     }

//     // Get inspection by ID
//     async getInspection(inspectionId) {
//         if (!this.db) await this.initDB();

//         const tx = this.db.transaction('inspections', 'readonly');
//         const inspection = await tx.objectStore('inspections').get(inspectionId);
//         await tx.done;

//         return inspection;
//     }

//     // Update inspection method
//     async updateInspection(dateTime, updatedData, eventType, reportType, imo_number) {
//         if (!this.db) await this.initDB();

//         try {
//             // Find existing inspection first
//             const tx1 = this.db.transaction('inspections', 'readonly');
//             const index = tx1.objectStore('inspections').index('dateTime');
//             const existingInspection = await index.get(dateTime);
//             await tx1.done;

//             if (!existingInspection) {
//                 throw new Error('Inspection not found');
//             }

//             const inspectionId = existingInspection.id;

//             // Process image data
//             const processedData = this.processImageData(updatedData);

//             // Update inspection record
//             const tx2 = this.db.transaction('inspections', 'readwrite');
//             const updatedInspection = {
//                 ...existingInspection,
//                 eventType,
//                 reportType: reportType || existingInspection.reportType || null,
//                 imo_number,
//                 data: processedData,
//                 updatedAt: new Date().toISOString(),
//                 imageCount: this.countImages(processedData)
//             };

//             await tx2.objectStore('inspections').put(updatedInspection);
//             await tx2.done;

//             return inspectionId;
//         } catch (error) {
//             console.error('Error updating inspection:', error);
//             throw error;
//         }
//     }

//     // List inspections with optional image filtering
//     async listInspections(filters = {}, options = {}) {
//         if (!this.db) await this.initDB();

//         const tx = this.db.transaction('inspections', 'readonly');
//         const inspectionStore = tx.objectStore('inspections');

//         let inspections = [];

//         // Get inspections using existing filter logic with reportType support
//         if (filters.eventType && filters.reportType && filters.dateTime && filters.imo_number) {
//             const index = inspectionStore.index('compositeWithReport');
//             inspections = await index.getAll([filters.eventType, filters.reportType, filters.dateTime, filters.imo_number]);
//         } else if (filters.eventType && filters.dateTime && filters.imo_number) {
//             const index = inspectionStore.index('composite');
//             inspections = await index.getAll([filters.eventType, filters.dateTime, filters.imo_number]);
//         } else if (filters.eventType) {
//             const index = inspectionStore.index('eventType');
//             inspections = await index.getAll(filters.eventType);
//         } else if (filters.reportType) {
//             const index = inspectionStore.index('reportType');
//             inspections = await index.getAll(filters.reportType);
//         } else if (filters.dateTime) {
//             const index = inspectionStore.index('dateTime');
//             inspections = await index.getAll(filters.dateTime);
//         } else if (filters.imo_number) {
//             const index = inspectionStore.index('imo_number');
//             inspections = await index.getAll(filters.imo_number);
//         } else {
//             inspections = await inspectionStore.getAll();
//         }

//         await tx.done;

//         // Apply additional filters
//         if (Object.keys(filters).length > 0) {
//             inspections = inspections.filter(inspection => {
//                 return Object.entries(filters).every(([key, value]) => {
//                     if (!value) return true;
//                     return inspection[key] === value;
//                 });
//             });
//         }

//         // Sort by date (newest first)
//         inspections.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));

//         // Process options if needed
//         const {
//             includeImages = true,
//             limitImages = null,
//             onlyFirstImage = false
//         } = options;

//         if (!includeImages) {
//             // Remove image data to reduce memory usage
//             return inspections.map(inspection => ({
//                 ...inspection,
//                 data: this.removeImagesFromData(inspection.data)
//             }));
//         }

//         // Apply image limits if specified
//         if (limitImages || onlyFirstImage) {
//             return inspections.map(inspection => ({
//                 ...inspection,
//                 data: this.limitImagesInData(inspection.data, limitImages, onlyFirstImage)
//             }));
//         }

//         return inspections;
//     }

//     // Helper method to remove images from data
//     removeImagesFromData(data) {
//         const processedData = JSON.parse(JSON.stringify(data));

//         for (const step of processedData) {
//             // Remove common images
//             if (step.common_data && step.common_data.images) {
//                 step.common_data.images = step.common_data.images.map(img => ({
//                     ...img,
//                     image_url: null // Remove image data
//                 }));
//             }

//             // Remove unit images
//             for (const unit of step.units) {
//                 if (unit.images) {
//                     unit.images = unit.images.map(img => ({
//                         ...img,
//                         image_url: null // Remove image data
//                     }));
//                 }
//             }
//         }

//         return processedData;
//     }

//     // Helper method to limit images in data
//     limitImagesInData(data, limitImages, onlyFirstImage) {
//         const processedData = JSON.parse(JSON.stringify(data));
//         let totalImageCount = 0;
//         const maxImages = onlyFirstImage ? 1 : limitImages;

//         for (const step of processedData) {
//             // Limit common images
//             if (step.common_data && step.common_data.images) {
//                 if (maxImages && totalImageCount >= maxImages) {
//                     step.common_data.images = [];
//                 } else {
//                     const remaining = maxImages ? maxImages - totalImageCount : step.common_data.images.length;
//                     step.common_data.images = step.common_data.images.slice(0, remaining);
//                     totalImageCount += step.common_data.images.length;
//                 }
//             }

//             // Limit unit images
//             for (const unit of step.units) {
//                 if (unit.images) {
//                     if (maxImages && totalImageCount >= maxImages) {
//                         unit.images = [];
//                     } else {
//                         const remaining = maxImages ? maxImages - totalImageCount : unit.images.length;
//                         unit.images = unit.images.slice(0, remaining);
//                         totalImageCount += unit.images.length;
//                     }
//                 }
//             }

//             if (maxImages && totalImageCount >= maxImages) break;
//         }

//         return processedData;
//     }

//     // Storage management methods
//     async getStorageInfo() {
//         if (!navigator.storage || !navigator.storage.estimate) {
//             return { error: 'Storage API not supported' };
//         }

//         try {
//             const estimate = await navigator.storage.estimate();
//             const used = estimate.usage || 0;
//             const quota = estimate.quota || 0;

//             return {
//                 used: this.formatBytes(used),
//                 quota: this.formatBytes(quota),
//                 available: this.formatBytes(quota - used),
//                 usagePercentage: ((used / quota) * 100).toFixed(2) + '%',
//                 raw: { used, quota, available: quota - used }
//             };
//         } catch (error) {
//             return { error: 'Failed to get storage info' };
//         }
//     }

//     async updateStorageInfo() {
//         const info = await this.getStorageInfo();
//         if (!info.error) {
//             this.storageQuota = info.raw.quota;
//             this.usedStorage = info.raw.used;
//         }
//         return info;
//     }

//     getAvailableStorage() {
//         return this.storageQuota - this.usedStorage;
//     }

//     async checkStorageCapacity(estimatedSize) {
//         const availableStorage = this.getAvailableStorage();
//         const safetyMargin = 50 * 1024 * 1024; // 50MB safety margin

//         return availableStorage > (estimatedSize + safetyMargin);
//     }

//     async estimatePayloadSize(inspectionData) {
//         let estimatedSize = 0;

//         for (const step of inspectionData) {
//             // Estimate common images
//             if (step.common_data && step.common_data.images) {
//                 for (const image of step.common_data.images) {
//                     if (image.image_url && typeof image.image_url === 'string') {
//                         estimatedSize += this.getBase64Size(image.image_url);
//                     }
//                 }
//             }

//             // Estimate unit images
//             for (const unit of step.units) {
//                 if (unit.images) {
//                     for (const image of unit.images) {
//                         if (image.image_url && typeof image.image_url === 'string') {
//                             estimatedSize += this.getBase64Size(image.image_url);
//                         }
//                     }
//                 }
//             }
//         }

//         // Add overhead for metadata and indexes
//         return estimatedSize * 1.2;
//     }

//     // Get base64 size in bytes
//     getBase64Size(base64String) {
//         if (!base64String) return 0;

//         // Remove data URL prefix if present
//         const base64 = base64String.includes(',') ? base64String.split(',')[1] : base64String;
//         return Math.round((base64.length * 3) / 4);
//     }

//     // Utility methods
//     formatBytes(bytes) {
//         if (bytes === 0) return '0 Bytes';
//         const k = 1024;
//         const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//         const i = Math.floor(Math.log(bytes) / Math.log(k));
//         return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
//     }

//     // Clean up methods
//     async cleanupOldInspections(daysToKeep = 30) {
//         if (!this.db) await this.initDB();

//         const cutoffDate = new Date();
//         cutoffDate.setDate(cutoffDate.getDate() - daysToKeep);

//         const tx = this.db.transaction('inspections', 'readwrite');
//         const inspectionStore = tx.objectStore('inspections');

//         const inspections = await inspectionStore.getAll();
//         let deletedCount = 0;

//         for (const inspection of inspections) {
//             if (new Date(inspection.createdAt) < cutoffDate) {
//                 await inspectionStore.delete(inspection.id);
//                 deletedCount++;
//             }
//         }

//         await tx.done;
//         await this.updateStorageInfo();

//         return { deletedInspections: deletedCount, newStorageInfo: await this.getStorageInfo() };
//     }

//     async clearAllData() {
//         if (!this.db) await this.initDB();

//         const tx = this.db.transaction('inspections', 'readwrite');
//         await tx.objectStore('inspections').clear();
//         await tx.done;
//     }

//     async getStorageUsage() {
//         if (!this.db) await this.initDB();

//         const tx = this.db.transaction('inspections', 'readonly');
//         const inspectionStore = tx.objectStore('inspections');

//         const inspections = await inspectionStore.getAll();
//         const inspectionCount = inspections.length;

//         let totalImageCount = 0;
//         let totalSize = 0;

//         for (const inspection of inspections) {
//             totalImageCount += inspection.imageCount || 0;

//             // Rough estimate of inspection size
//             const inspectionString = JSON.stringify(inspection);
//             totalSize += new Blob([inspectionString]).size;
//         }

//         await tx.done;

//         return {
//             inspectionCount,
//             imageCount: totalImageCount,
//             totalSize: this.formatBytes(totalSize),
//             averageImagesPerInspection: inspectionCount > 0 ? (totalImageCount / inspectionCount).toFixed(1) : 0
//         };
//     }

//     // Delete specific inspection
//     async deleteInspection(inspectionId) {
//         if (!this.db) await this.initDB();

//         const tx = this.db.transaction('inspections', 'readwrite');
//         await tx.objectStore('inspections').delete(inspectionId);
//         await tx.done;

//         await this.updateStorageInfo();
//         return true;
//     }

//     // Get inspection count
//     async getInspectionCount() {
//         if (!this.db) await this.initDB();

//         const tx = this.db.transaction('inspections', 'readonly');
//         const count = await tx.objectStore('inspections').count();
//         await tx.done;

//         return count;
//     }


//     //SHIP LOGIC
//     async addShip(shipData) {
//         try {
//             await this.initDB();

//             const ship = {
//                 ...shipData,
//                 created_at: new Date().toISOString(),
//                 updated_at: new Date().toISOString(),
//                 synced: shipData.synced || false // Default to unsynced
//             };

//             const id = await this.db.add('ships', ship);
//             const newShip = { ...ship, id };

//             await this.updateStorageInfo();
//             return newShip;
//         } catch (error) {
//             console.error('Error adding ship to IndexedDB:', error);
//             throw error;
//         }
//     }

//     // Get all ships from IndexedDB for a specific user
//     async getAllShips(userId) {
//         try {
//             await this.initDB();

//             const tx = this.db.transaction('ships', 'readonly');
//             const ships = await tx.store.index('user_id').getAll(userId);

//             // Sort by updated_at descending
//             return ships.sort((a, b) =>
//                 new Date(b.updated_at) - new Date(a.updated_at)
//             );
//         } catch (error) {
//             console.error('Error getting ships from IndexedDB:', error);
//             throw error;
//         }
//     }

//     // Update ship in IndexedDB
//     async updateShip(shipId, updateData) {
//         try {
//             await this.initDB();

//             // Get existing ship
//             const existingShip = await this.db.get('ships', shipId);

//             if (!existingShip) {
//                 throw new Error('Ship not found');
//             }

//             const updatedShip = {
//                 ...existingShip,
//                 ...updateData,
//                 updated_at: new Date().toISOString()
//             };

//             await this.db.put('ships', updatedShip);
//             await this.updateStorageInfo();
//             return updatedShip;
//         } catch (error) {
//             console.error('Error updating ship in IndexedDB:', error);
//             throw error;
//         }
//     }

//     // Delete ship from IndexedDB
//     async deleteShip(shipId) {
//         try {
//             await this.initDB();

//             await this.db.delete('ships', shipId);
//             await this.updateStorageInfo();
//             return true;
//         } catch (error) {
//             console.error('Error deleting ship from IndexedDB:', error);
//             throw error;
//         }
//     }

//     // Get ship by ID
//     async getShipById(shipId) {
//         try {
//             await this.initDB();
//             return await this.db.get('ships', shipId);
//         } catch (error) {
//             console.error('Error getting ship by ID:', error);
//             throw error;
//         }
//     }

//     async saveFormConfiguration(eventType, reportType, configData) {
//         await this.initDB();

//         try {
//             const tx = this.db.transaction(['formConfigurations'], 'readwrite');
//             const store = tx.objectStore('formConfigurations');

//             // Use composite key [eventType, reportType]
//             const compositeKey = [eventType, reportType || null];

//             // Check if record already exists
//             const existingRecord = await store.get(compositeKey);

//             let formConfigRecord;

//             if (existingRecord) {
//                 // Update existing record
//                 formConfigRecord = {
//                     ...existingRecord,
//                     formConfigurations: configData || [],
//                     lastUpdated: new Date().toISOString(),
//                     synced: false // Mark as not synced after update
//                 };
//                 console.log(`Updating existing form configuration for eventType: ${eventType}, reportType: ${reportType}`);
//             } else {
//                 // Create new record
//                 formConfigRecord = {
//                     eventType: eventType,
//                     reportType: reportType || null,
//                     formConfigurations: configData || [],
//                     lastUpdated: new Date().toISOString(),
//                     synced: false,
//                     status: 'ACTIVE'
//                 };
//                 console.log(`Creating new form configuration for eventType: ${eventType}, reportType: ${reportType}`);
//             }

//             await store.put(formConfigRecord);
//             await tx.complete;

//             console.log(`Form configuration saved successfully for eventType: ${eventType}, reportType: ${reportType}`);
//             return compositeKey;
//         } catch (error) {
//             console.error('Error saving form configuration:', error);
//             throw error;
//         }
//     }

//     async getFormConfiguration(eventType, reportType = null) {
//         await this.initDB();

//         try {
//             const tx = this.db.transaction(['formConfigurations'], 'readonly');
//             const store = tx.objectStore('formConfigurations');

//             // Use composite key [eventType, reportType]
//             const compositeKey = [eventType, reportType];
//             const result = await store.get(compositeKey);
//             return result || null;
//         } catch (error) {
//             console.error('Error getting form configuration:', error);
//             throw error;
//         }
//     }

//     // Get all form configurations from IndexedDB
//     async getAllFormConfig() {
//         try {
//             await this.initDB();

//             const tx = this.db.transaction("formConfigurations", "readonly");
//             const store = tx.store;

//             // Get all records
//             const formConfigs = await store.getAll();

//             return formConfigs?.map(x => ({
//                 event_type: x?.eventType,
//                 report_type: x?.reportType,
//                 value: `${x?.eventType}${x?.reportType ? `_${x?.reportType}` : ''}`
//             }));
//         } catch (error) {
//             console.error("Error getting formConfigurations from IndexedDB:", error);
//             throw error;
//         }
//     }

//     async syncAndClearFormConfigs() {
//         try {
//             await this.initDB();

//             // 👉 First transaction just to read
//             const tx1 = this.db.transaction("formConfigurations", "readonly");
//             const store1 = tx1.store;
//             const formConfigs = await store1.getAll();
//             await tx1.done;

//             if (!formConfigs || formConfigs.length === 0) {
//                 console.log("No formConfigurations to sync.");
//                 return;
//             }

//             // 1️⃣ Call API
//             const response = await formCreationService.syncFormConfiguration(formConfigs);
//             if (!response) throw new Error("Sync failed");

//             // 👉 Second transaction to delete
//             const tx2 = this.db.transaction("formConfigurations", "readwrite");
//             const store2 = tx2.store;

//             for (let cfg of formConfigs) {
//                 if (cfg?.eventType) {
//                     const compositeKey = [cfg.eventType, cfg.reportType || null];
//                     console.log("Deleting eventType:", cfg.eventType, "reportType:", cfg.reportType);
//                     await store2.delete(compositeKey);
//                 }
//             }
//             await tx2.done;

//             console.log("Sync successful, local IndexedDB records cleared.");
//         } catch (error) {
//             console.error("Error syncing formConfigurations:", error);
//         }
//     }

//     async getUnsyncedFormConfigurations() {
//         await this.initDB();

//         try {
//             const tx = this.db.transaction(['formConfigurations'], 'readonly');
//             const store = tx.objectStore('formConfigurations');
//             const index = store.index('synced');

//             const result = await index.getAll(false);
//             return result || [];
//         } catch (error) {
//             console.error('Error getting unsynced form configurations:', error);
//             throw error;
//         }
//     }
//     async getInspectionsByReportType(reportType, options = {}) {
//         if (!this.db) await this.initDB();

//         try {
//             const tx = this.db.transaction('inspections', 'readonly');
//             const inspectionStore = tx.objectStore('inspections');
//             const reportTypeIndex = inspectionStore.index('reportType');

//             // Get all inspections matching the reportType
//             let inspections = await reportTypeIndex.getAll(reportType);
//             await tx.done;

//             // Sort by date (newest first)
//             inspections.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));

//             // Process options for image handling
//             const {
//                 includeImages = true,
//                 limitImages = null,
//                 onlyFirstImage = false,
//                 limit = null,
//                 offset = 0
//             } = options;

//             // Apply pagination if specified
//             if (limit || offset) {
//                 const startIndex = offset || 0;
//                 const endIndex = limit ? startIndex + limit : inspections.length;
//                 inspections = inspections.slice(startIndex, endIndex);
//             }

//             if (!includeImages) {
//                 // Remove image data to reduce memory usage
//                 return inspections.map(inspection => ({
//                     ...inspection,
//                     data: this.removeImagesFromData(inspection.data)
//                 }));
//             }

//             // Apply image limits if specified
//             if (limitImages || onlyFirstImage) {
//                 return inspections.map(inspection => ({
//                     ...inspection,
//                     data: this.limitImagesInData(inspection.data, limitImages, onlyFirstImage)
//                 }));
//             }

//             return inspections;

//         } catch (error) {
//             console.error('Error getting inspections by reportType:', error);
//             throw error;
//         }
//     }

//     //     const inspections = await db.getInspectionsByReportType('DAILY_REPORT');
//     // // With options
//     // const inspections = await db.getInspectionsByReportType('WEEKLY_REPORT', {
//     //     includeImages: false,        // Exclude images for performance
//     //     limit: 10,                   // Limit to 10 results
//     //     offset: 0,                   // Starting from first record
//     //     onlyFirstImage: true         // Include only first image per inspection
//     // });

// }

// export default InspectionDB;



// inspectionDB.js
import { openDB } from 'idb';
import formCreationService from '../formconfiguration.service';

// Simplified IndexedDB Helper Class
class InspectionDB {
    constructor() {
        this.dbName = 'InspectionDB';
        this.version = 7; // Increment version for schema changes to add user_id
        this.db = null;
        this.storageQuota = null;
        this.usedStorage = 0;
    }

    async initDB() {
        if (this.db) return this.db;

        this.db = await openDB(this.dbName, this.version, {
            upgrade(db, oldVersion, newVersion, transaction) {
                // Single inspections store (stores ALL data including images)
                if (!db.objectStoreNames.contains('inspections')) {
                    const inspectionStore = db.createObjectStore('inspections', {
                        keyPath: 'id',
                        autoIncrement: true
                    });

                    // Create indexes for efficient querying
                    inspectionStore.createIndex('user_id', 'user_id');
                    inspectionStore.createIndex('dateTime', 'dateTime');
                    inspectionStore.createIndex('eventType', 'eventType');
                    inspectionStore.createIndex('reportType', 'reportType');
                    inspectionStore.createIndex('imo_number', 'imo_number');
                    inspectionStore.createIndex('composite', ['user_id', 'eventType', 'dateTime', 'imo_number']);
                    inspectionStore.createIndex('compositeWithReport', ['user_id', 'eventType', 'reportType', 'dateTime', 'imo_number']);
                    inspectionStore.createIndex('userEventType', ['user_id', 'eventType']);
                    inspectionStore.createIndex('userReportType', ['user_id', 'reportType']);
                    inspectionStore.createIndex('userDateTime', ['user_id', 'dateTime']);
                    inspectionStore.createIndex('userImo', ['user_id', 'imo_number']);
                } else {
                    // Handle upgrades for existing inspections store
                    const inspectionStore = transaction.objectStore('inspections');

                    // Add user_id index if it doesn't exist
                    if (!inspectionStore.indexNames.contains('user_id')) {
                        inspectionStore.createIndex('user_id', 'user_id');
                    }

                    // Add reportType index if it doesn't exist
                    if (!inspectionStore.indexNames.contains('reportType')) {
                        inspectionStore.createIndex('reportType', 'reportType');
                    }

                    // Update composite indexes to include user_id
                    if (!inspectionStore.indexNames.contains('userEventType')) {
                        inspectionStore.createIndex('userEventType', ['user_id', 'eventType']);
                    }
                    if (!inspectionStore.indexNames.contains('userReportType')) {
                        inspectionStore.createIndex('userReportType', ['user_id', 'reportType']);
                    }
                    if (!inspectionStore.indexNames.contains('userDateTime')) {
                        inspectionStore.createIndex('userDateTime', ['user_id', 'dateTime']);
                    }
                    if (!inspectionStore.indexNames.contains('userImo')) {
                        inspectionStore.createIndex('userImo', ['user_id', 'imo_number']);
                    }

                    // Update existing composite indexes if they don't include user_id
                    if (oldVersion < 6) {
                        // Drop old indexes if they exist
                        if (inspectionStore.indexNames.contains('composite')) {
                            inspectionStore.deleteIndex('composite');
                        }
                        if (inspectionStore.indexNames.contains('compositeWithReport')) {
                            inspectionStore.deleteIndex('compositeWithReport');
                        }

                        // Create new user-based composite indexes
                        inspectionStore.createIndex('composite', ['user_id', 'eventType', 'dateTime', 'imo_number']);
                        inspectionStore.createIndex('compositeWithReport', ['user_id', 'eventType', 'reportType', 'dateTime', 'imo_number']);
                    }
                }
                if (!db.objectStoreNames.contains('formConfigurations')) {

                    const formConfigStore = db.createObjectStore('formConfigurations', {
                        keyPath: ['user_id', 'eventType', 'reportType'] // Composite key with user_id, eventType and reportType
                    });
                    // Create indexes for efficient querying
                    formConfigStore.createIndex('user_id', 'user_id');
                    formConfigStore.createIndex('eventType', 'eventType'); // ✅ add this
                    formConfigStore.createIndex('reportType', 'reportType'); // ✅ added reportType
                    formConfigStore.createIndex('lastUpdated', 'lastUpdated');
                    formConfigStore.createIndex('synced', 'synced', { unique: false });
                    formConfigStore.createIndex('status', 'status', { unique: false });

                } else if (oldVersion < 6) {
                    // Handle upgrade for formConfigurations store to include new indexes
                    const formConfigStore = transaction.objectStore('formConfigurations');

                    // Add user_id index if missing
                    if (!formConfigStore.indexNames.contains('user_id')) {
                        formConfigStore.createIndex('user_id', 'user_id');
                    }
                    if (!formConfigStore.indexNames.contains('eventType')) {
                        formConfigStore.createIndex('eventType', 'eventType'); // ✅ add here too
                    }
                    // ✅ Add reportType index if missing
                    if (!formConfigStore.indexNames.contains('reportType')) {
                        formConfigStore.createIndex('reportType', 'reportType');
                    }
                }


                if (!db.objectStoreNames.contains('ships')) {
                    const shipStore = db.createObjectStore('ships', {
                        keyPath: 'id',
                        autoIncrement: true
                    });

                    // Create indexes
                    shipStore.createIndex('user_id', 'user_id', { unique: false });
                    shipStore.createIndex('imo_number', 'imo_number', { unique: false });
                    shipStore.createIndex('server_id', 'server_id', { unique: false });
                    shipStore.createIndex('synced', 'synced', { unique: false });
                } else if (oldVersion < 2) {
                    // Add synced index if upgrading from version 1
                    const shipStore = transaction.objectStore('ships');
                    if (!shipStore.indexNames.contains('synced')) {
                        shipStore.createIndex('synced', 'synced', { unique: false });
                    }
                }
            }
        });

        // Initialize storage info
        await this.updateStorageInfo();
        return this.db;
    }

    // Main createInspection method - stores everything in one table
    async createInspection(user_id, payload, onProgress = null) {
        if (!this.db) await this.initDB();

        let inspectionData, eventType, reportType, dateTime, imo_number, timestamp;

        if (typeof payload === 'object' && payload.data && payload.eventType) {
            ({ data: inspectionData, eventType, reportType, dateTime, imo_number, timestamp } = payload);
        } else {
            [inspectionData, eventType, reportType, dateTime, imo_number] = [payload, ...Array.from(arguments).slice(2)];
        }

        try {
            // Check storage before processing
            await this.updateStorageInfo();
 
            const estimatedSize = await this.estimatePayloadSize(inspectionData);

            if (!await this.checkStorageCapacity(estimatedSize)) {
                throw new Error(`Insufficient storage. Need: ${this.formatBytes(estimatedSize)}, Available: ${this.formatBytes(this.getAvailableStorage())}`);
            }

            if (onProgress) onProgress({ stage: 'preprocessing', progress: 20 });

            // Process images to ensure proper format
            const processedData = this.processImageData(inspectionData);

            if (onProgress) onProgress({ stage: 'storing_data', progress: 60 });

            // Store inspection with all data in single record
            const tx = this.db.transaction('inspections', 'readwrite');
            const inspection = {
                user_id,
                eventType,
                reportType: reportType || null, // Allow null reportType for backward compatibility
                dateTime,
                imo_number,
                data: processedData, // Store complete data including images
                createdAt: new Date().toISOString(),
                imageCount: this.countImages(processedData)
            };

            const inspectionResult = await tx.objectStore('inspections').add(inspection);
            const inspectionId = inspectionResult;
            await tx.done;

            if (onProgress) onProgress({ stage: 'complete', progress: 100 });

            // Update storage info after successful creation
            await this.updateStorageInfo();

            return {
                inspectionId,
                imageCount: inspection.imageCount,
                storageInfo: await this.getStorageInfo()
            };

        } catch (error) {
            console.error('Error creating inspection:', error);
            throw error;
        }
    }

    // Process image data to ensure proper format (no compression)
    processImageData(inspectionData) {
        const processedData = JSON.parse(JSON.stringify(inspectionData));

        for (const step of processedData) {
            // Process common images
            if (step.common_data && step.common_data.images) {
                for (const image of step.common_data.images) {
                    if (image.image_url && typeof image.image_url === 'string') {
                        // Ensure it's a proper data URL
                        if (!image.image_url.startsWith('data:')) {
                            image.image_url = `data:image/png;base64,${image.image_url}`;
                        }
                    }
                }
            }

            // Process unit images
            for (const unit of step.units) {
                if (unit.images) {
                    for (const image of unit.images) {
                        if (image.image_url && typeof image.image_url === 'string') {
                            // Ensure it's a proper data URL
                            if (!image.image_url.startsWith('data:')) {
                                image.image_url = `data:image/png;base64,${image.image_url}`;
                            }
                        }
                    }
                }
            }
        }

        return processedData;
    }

    // Count total images in inspection data
    countImages(inspectionData) {
        let count = 0;

        for (const step of inspectionData) {
            // Count common images
            if (step.common_data && step.common_data.images) {
                count += step.common_data.images.length;
            }

            // Count unit images
            for (const unit of step.units) {
                if (unit.images) {
                    count += unit.images.length;
                }
            }
        }

        return count;
    }

    // Get inspection by ID (user-specific)
    async getInspection(user_id, inspectionId) {
        if (!this.db) await this.initDB();

        const tx = this.db.transaction('inspections', 'readonly');
        const inspection = await tx.objectStore('inspections').get(inspectionId);
        await tx.done;

        // Verify user ownership
        if (inspection && inspection.user_id !== user_id) {
            throw new Error('Access denied: Inspection belongs to different user');
        }

        return inspection;
    }

    // Update inspection method
    async updateInspection(user_id, dateTime, updatedData, eventType, reportType, imo_number) {
        if (!this.db) await this.initDB();

        try {
            // Find existing inspection first (user-specific)
            const tx1 = this.db.transaction('inspections', 'readonly');
            const index = tx1.objectStore('inspections').index('userDateTime');
            const existingInspection = await index.get([user_id, dateTime]);
            await tx1.done;

            if (!existingInspection) {
                throw new Error('Inspection not found');
            }

            const inspectionId = existingInspection.id;

            // Process image data
            const processedData = this.processImageData(updatedData);

            // Update inspection record
            const tx2 = this.db.transaction('inspections', 'readwrite');
            const updatedInspection = {
                ...existingInspection,
                eventType,
                reportType: reportType || existingInspection.reportType || null,
                imo_number,
                data: processedData,
                updatedAt: new Date().toISOString(),
                imageCount: this.countImages(processedData)
            };

            await tx2.objectStore('inspections').put(updatedInspection);
            await tx2.done;

            return inspectionId;
        } catch (error) {
            console.error('Error updating inspection:', error);
            throw error;
        }
    }

    // List inspections with optional image filtering (user-specific)
    async listInspections(user_id, filters = {}, options = {}) {
        if (!this.db) await this.initDB();

        const tx = this.db.transaction('inspections', 'readonly');
        const inspectionStore = tx.objectStore('inspections');

        let inspections = [];

        // Get inspections using existing filter logic with user_id and reportType support
        if (filters.eventType && filters.reportType && filters.dateTime && filters.imo_number) {
            const index = inspectionStore.index('compositeWithReport');
            inspections = await index.getAll([user_id, filters.eventType, filters.reportType, filters.dateTime, filters.imo_number]);
        } else if (filters.eventType && filters.dateTime && filters.imo_number) {
            const index = inspectionStore.index('composite');
            inspections = await index.getAll([user_id, filters.eventType, filters.dateTime, filters.imo_number]);
        } else if (filters.eventType) {
            const index = inspectionStore.index('userEventType');
            inspections = await index.getAll([user_id, filters.eventType]);
        } else if (filters.reportType) {
            const index = inspectionStore.index('userReportType');
            inspections = await index.getAll([user_id, filters.reportType]);
        } else if (filters.dateTime) {
            const index = inspectionStore.index('userDateTime');
            inspections = await index.getAll([user_id, filters.dateTime]);
        } else if (filters.imo_number) {
            const index = inspectionStore.index('userImo');
            inspections = await index.getAll([user_id, filters.imo_number]);
        } else {
            // Get all inspections for user
            const index = inspectionStore.index('user_id');
            inspections = await index.getAll(user_id);
        }

        await tx.done;

        // Apply additional filters
        if (Object.keys(filters).length > 0) {
            inspections = inspections.filter(inspection => {
                return Object.entries(filters).every(([key, value]) => {
                    if (!value) return true;
                    return inspection[key] === value;
                });
            });
        }

        // Sort by date (newest first)
        inspections.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));

        // Process options if needed
        const {
            includeImages = true,
            limitImages = null,
            onlyFirstImage = false
        } = options;

        if (!includeImages) {
            // Remove image data to reduce memory usage
            return inspections.map(inspection => ({
                ...inspection,
                data: this.removeImagesFromData(inspection.data)
            }));
        }

        // Apply image limits if specified
        if (limitImages || onlyFirstImage) {
            return inspections.map(inspection => ({
                ...inspection,
                data: this.limitImagesInData(inspection.data, limitImages, onlyFirstImage)
            }));
        }

        return inspections;
    }

    // Helper method to remove images from data
    removeImagesFromData(data) {
        const processedData = JSON.parse(JSON.stringify(data));

        for (const step of processedData) {
            // Remove common images
            if (step.common_data && step.common_data.images) {
                step.common_data.images = step.common_data.images.map(img => ({
                    ...img,
                    image_url: null // Remove image data
                }));
            }

            // Remove unit images
            for (const unit of step.units) {
                if (unit.images) {
                    unit.images = unit.images.map(img => ({
                        ...img,
                        image_url: null // Remove image data
                    }));
                }
            }
        }

        return processedData;
    }

    // Helper method to limit images in data
    limitImagesInData(data, limitImages, onlyFirstImage) {
        const processedData = JSON.parse(JSON.stringify(data));
        let totalImageCount = 0;
        const maxImages = onlyFirstImage ? 1 : limitImages;

        for (const step of processedData) {
            // Limit common images
            if (step.common_data && step.common_data.images) {
                if (maxImages && totalImageCount >= maxImages) {
                    step.common_data.images = [];
                } else {
                    const remaining = maxImages ? maxImages - totalImageCount : step.common_data.images.length;
                    step.common_data.images = step.common_data.images.slice(0, remaining);
                    totalImageCount += step.common_data.images.length;
                }
            }

            // Limit unit images
            for (const unit of step.units) {
                if (unit.images) {
                    if (maxImages && totalImageCount >= maxImages) {
                        unit.images = [];
                    } else {
                        const remaining = maxImages ? maxImages - totalImageCount : unit.images.length;
                        unit.images = unit.images.slice(0, remaining);
                        totalImageCount += unit.images.length;
                    }
                }
            }

            if (maxImages && totalImageCount >= maxImages) break;
        }

        return processedData;
    }

    // Storage management methods (remain mostly unchanged as they're global)
    async getStorageInfo() {
        if (!navigator.storage || !navigator.storage.estimate) {
            return { error: 'Storage API not supported' };
        }

        try {
            const estimate = await navigator.storage.estimate();
            const used = estimate.usage || 0;
            const quota = estimate.quota || 0;

            return {
                used: this.formatBytes(used),
                quota: this.formatBytes(quota),
                available: this.formatBytes(quota - used),
                usagePercentage: ((used / quota) * 100).toFixed(2) + '%',
                raw: { used, quota, available: quota - used }
            };
        } catch (error) {
            return { error: 'Failed to get storage info' };
        }
    }

    async updateStorageInfo() {
        const info = await this.getStorageInfo();
        if (!info.error) {
            this.storageQuota = info.raw.quota;
            this.usedStorage = info.raw.used;
        }
        return info;
    }

    getAvailableStorage() {
        return this.storageQuota - this.usedStorage;
    }

    async checkStorageCapacity(estimatedSize) {
        const availableStorage = this.getAvailableStorage();
        const safetyMargin = 50 * 1024 * 1024; // 50MB safety margin

        return availableStorage > (estimatedSize + safetyMargin);
    }

    async estimatePayloadSize(inspectionData) {
        let estimatedSize = 0;
        for (const step of inspectionData) {
            // Estimate common images
            if (step.common_data && step.common_data.images) {
                for (const image of step.common_data.images) {
                    if (image.image_url && typeof image.image_url === 'string') {
                        estimatedSize += this.getBase64Size(image.image_url);
                    }
                }
            }

            // Estimate unit images
            for (const unit of step.units) {
                if (unit.images) {
                    for (const image of unit.images) {
                        if (image.image_url && typeof image.image_url === 'string') {
                            estimatedSize += this.getBase64Size(image.image_url);
                        }
                    }
                }
            }
        }

        // Add overhead for metadata and indexes
        return estimatedSize * 1.2;
    }

    // Get base64 size in bytes
    getBase64Size(base64String) {
        if (!base64String) return 0;

        // Remove data URL prefix if present
        const base64 = base64String.includes(',') ? base64String.split(',')[1] : base64String;
        return Math.round((base64.length * 3) / 4);
    }

    // Utility methods
    formatBytes(bytes) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    // Clean up methods (user-specific)
    async cleanupOldInspections(user_id, daysToKeep = 30) {
        if (!this.db) await this.initDB();

        const cutoffDate = new Date();
        cutoffDate.setDate(cutoffDate.getDate() - daysToKeep);

        const tx = this.db.transaction('inspections', 'readwrite');
        const inspectionStore = tx.objectStore('inspections');
        const userIndex = inspectionStore.index('user_id');

        const inspections = await userIndex.getAll(user_id);
        let deletedCount = 0;

        for (const inspection of inspections) {
            if (new Date(inspection.createdAt) < cutoffDate) {
                await inspectionStore.delete(inspection.id);
                deletedCount++;
            }
        }

        await tx.done;
        await this.updateStorageInfo();

        return { deletedInspections: deletedCount, newStorageInfo: await this.getStorageInfo() };
    }

    async clearAllData(user_id = null) {
        if (!this.db) await this.initDB();

        if (user_id) {
            // Clear data for specific user only
            const tx = this.db.transaction(['inspections', 'ships', 'formConfigurations'], 'readwrite');

            // Clear user's inspections
            const inspectionStore = tx.objectStore('inspections');
            const userInspections = await inspectionStore.index('user_id').getAll(user_id);
            for (const inspection of userInspections) {
                await inspectionStore.delete(inspection.id);
            }

            // Clear user's ships
            const shipStore = tx.objectStore('ships');
            const userShips = await shipStore.index('user_id').getAll(user_id);
            for (const ship of userShips) {
                await shipStore.delete(ship.id);
            }

            // Clear user's form configurations
            const formConfigStore = tx.objectStore('formConfigurations');
            const userFormConfigs = await formConfigStore.index('user_id').getAll(user_id);
            for (const config of userFormConfigs) {
                const compositeKey = [config.user_id, config.eventType, config.reportType];
                await formConfigStore.delete(compositeKey);
            }

            await tx.done;
        } else {
            // Clear all data (admin function)
            const tx = this.db.transaction(['inspections', 'ships', 'formConfigurations'], 'readwrite');
            await tx.objectStore('inspections').clear();
            await tx.objectStore('ships').clear();
            await tx.objectStore('formConfigurations').clear();
            await tx.done;
        }
    }

    async getStorageUsage(user_id = null) {
        if (!this.db) await this.initDB();

        const tx = this.db.transaction('inspections', 'readonly');
        const inspectionStore = tx.objectStore('inspections');

        let inspections;
        if (user_id) {
            const userIndex = inspectionStore.index('user_id');
            inspections = await userIndex.getAll(user_id);
        } else {
            inspections = await inspectionStore.getAll();
        }

        const inspectionCount = inspections.length;

        let totalImageCount = 0;
        let totalSize = 0;

        for (const inspection of inspections) {
            totalImageCount += inspection.imageCount || 0;

            // Rough estimate of inspection size
            const inspectionString = JSON.stringify(inspection);
            totalSize += new Blob([inspectionString]).size;
        }

        await tx.done;

        return {
            inspectionCount,
            imageCount: totalImageCount,
            totalSize: this.formatBytes(totalSize),
            averageImagesPerInspection: inspectionCount > 0 ? (totalImageCount / inspectionCount).toFixed(1) : 0
        };
    }

    // Delete specific inspection (user-specific)
    async deleteInspection(user_id, inspectionId) {
        if (!this.db) await this.initDB();

        // First verify the inspection belongs to the user
        const inspection = await this.getInspection(user_id, inspectionId);
        if (!inspection) {
            throw new Error('Inspection not found or access denied');
        }

        const tx = this.db.transaction('inspections', 'readwrite');
        await tx.objectStore('inspections').delete(inspectionId);
        await tx.done;

        await this.updateStorageInfo();
        return true;
    }

    // Get inspection count (user-specific)
    async getInspectionCount(user_id) {
        if (!this.db) await this.initDB();

        const tx = this.db.transaction('inspections', 'readonly');
        const userIndex = tx.objectStore('inspections').index('user_id');
        const count = await userIndex.count(user_id);
        await tx.done;

        return count;
    }

    //SHIP LOGIC
    async addShip(user_id, shipData) {
        try {
            await this.initDB();

            const ship = {
                ...shipData,
                user_id, // Ensure user_id is set
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
                synced: shipData.synced || false // Default to unsynced
            };

            const id = await this.db.add('ships', ship);
            const newShip = { ...ship, id };

            await this.updateStorageInfo();
            return newShip;
        } catch (error) {
            console.error('Error adding ship to IndexedDB:', error);
            throw error;
        }
    }

    // Get all ships from IndexedDB for a specific user
    async getAllShips(userId) {
        try {
            await this.initDB();

            const tx = this.db.transaction('ships', 'readonly');
            const ships = await tx.store.index('user_id').getAll(userId);

            // Sort by updated_at descending
            return ships.sort((a, b) =>
                new Date(b.updated_at) - new Date(a.updated_at)
            );
        } catch (error) {
            console.error('Error getting ships from IndexedDB:', error);
            throw error;
        }
    }

    // Update ship in IndexedDB (user-specific)
    async updateShip(user_id, shipId, updateData) {
        try {
            await this.initDB();

            // Get existing ship
            const existingShip = await this.db.get('ships', shipId);

            if (!existingShip) {
                throw new Error('Ship not found');
            }

            // Verify user ownership
            if (existingShip.user_id !== user_id) {
                throw new Error('Access denied: Ship belongs to different user');
            }

            const updatedShip = {
                ...existingShip,
                ...updateData,
                updated_at: new Date().toISOString()
            };

            await this.db.put('ships', updatedShip);
            await this.updateStorageInfo();
            return updatedShip;
        } catch (error) {
            console.error('Error updating ship in IndexedDB:', error);
            throw error;
        }
    }

    // Delete ship from IndexedDB (user-specific)
    async deleteShip(user_id, shipId) {
        try {
            await this.initDB();

            // Get existing ship to verify ownership
            const existingShip = await this.db.get('ships', shipId);

            if (!existingShip) {
                throw new Error('Ship not found');
            }

            // Verify user ownership
            if (existingShip.user_id !== user_id) {
                throw new Error('Access denied: Ship belongs to different user');
            }

            await this.db.delete('ships', shipId);
            await this.updateStorageInfo();
            return true;
        } catch (error) {
            console.error('Error deleting ship from IndexedDB:', error);
            throw error;
        }
    }

    // Get ship by ID (user-specific)
    async getShipById(user_id, shipId) {
        try {
            await this.initDB();
            const ship = await this.db.get('ships', shipId);

            // Verify user ownership
            if (ship && ship.user_id !== user_id) {
                throw new Error('Access denied: Ship belongs to different user');
            }

            return ship;
        } catch (error) {
            console.error('Error getting ship by ID:', error);
            throw error;
        }
    }
    async getFormConfigsByEventType(eventType) {
        await this.initDB();
         try {
            const tx = this.db.transaction(['formConfigurations'], 'readonly');
            const store = tx.objectStore('formConfigurations');
            const index = store.index('eventType'); // ✅ use eventType index
            const request = index.getAll(eventType);
            return request;
        } catch (error) {
            console.error('Error fetching form configurations by eventType:', error);
            throw error;
        }
    }

    async saveFormConfiguration(user_id, eventType, reportType, configData) {
        await this.initDB();
      

        try {
            const tx = this.db.transaction(['formConfigurations'], 'readwrite');
            const store = tx.objectStore('formConfigurations');

            // Use composite key [user_id, eventType, reportType]
            const compositeKey = [user_id, eventType, reportType || null];

            // Check if record already exists
            const existingRecord = await store.get(compositeKey);

            let formConfigRecord;

            if (existingRecord) {
                // Update existing record
                formConfigRecord = {
                    ...existingRecord,
                    formConfigurations: configData || [],
                    lastUpdated: new Date().toISOString(),
                    synced: false // Mark as not synced after update
                };
             } else {
                // Create new record
                formConfigRecord = {
                    user_id: user_id,
                    eventType: eventType,
                    reportType: reportType,
                    formConfigurations: configData || [],
                    lastUpdated: new Date().toISOString(),
                    synced: false,
                    status: 'ACTIVE'
                };
                console.log(`Creating new form configuration for user: ${user_id}, eventType: ${eventType} `);
            }

            await store.put(formConfigRecord);
            await tx.complete;

            console.log(`Form configuration saved successfully for user: ${user_id}, eventType: ${eventType} `);
            return compositeKey;
        } catch (error) {
            console.error('Error saving form configuration:', error);
            throw error;
        }
    }

    async insertIfNotExists(user_id, eventType, reportType, configData) {
        await this.initDB();
        console.log("user_id, eventType, reportType, configData", user_id, eventType, reportType, configData)
        try {
            const tx = this.db.transaction(['formConfigurations'], 'readwrite');
            const store = tx.objectStore('formConfigurations');
            const compositeKey = [user_id, eventType, reportType || null];
            const existingRecord = await store.get(compositeKey);
            let formConfigRecord;
            console.log("existingRecord",existingRecord)
         if (existingRecord) {
    formConfigRecord = {
        ...existingRecord,
        formConfigurations: configData || existingRecord.formConfigurations,
        lastUpdated: new Date().toISOString(),
        synced: false,
        status: 'ACTIVE'
    };
} else {
    formConfigRecord = {
        user_id,
        eventType,
        reportType,
        formConfigurations: configData || [],
        lastUpdated: new Date().toISOString(),
        synced: false,
        status: 'ACTIVE'
    };
}

// ✅ Just use put for both new + update
await store.put(formConfigRecord);
await tx.complete;

            
            console.log(`[IndexedDB] Inserted new form configuration for user=${user_id}, eventType=${eventType}, reportType=${reportType}`);
            return true;
        } catch (error) {
            console.error('Error inserting form configuration:', error);
            throw error;
        }
    }

    async getFormConfiguration(user_id, eventType) {
        await this.initDB();

        try {
            const tx = this.db.transaction(['formConfigurations'], 'readonly');
            const store = tx.objectStore('formConfigurations');

            const compositeKey = [user_id, eventType];
            const result = await store.get(compositeKey);
            return result || null;
        } catch (error) {
            console.error('Error getting form configuration:', error);
            throw error;
        }
    }

    // Get all form configurations from IndexedDB (user-specific)
    // async getAllFormConfig(user_id) {
    //     try {
    //         await this.initDB();

    //         const tx = this.db.transaction("formConfigurations", "readonly");
    //         const store = tx.store;
    //         const userIndex = store.index('user_id');

    //         // Get all records for the specific user
    //         const formConfigs = await userIndex.getAll(user_id);

    //         return formConfigs?.map(x => ({
    //             event_type: x?.eventType,
    //             value: `${x?.eventType}${x?.reportType ? `_${x?.reportType}` : ''}`
    //         }));
    //     } catch (error) {
    //         console.error("Error getting formConfigurations from IndexedDB:", error);
    //         throw error;
    //     }
    // }

    async getAllFormConfig(user_id, reportType = null) {
  try {
    await this.initDB();

    const tx = this.db.transaction("formConfigurations", "readonly");
    const store = tx.store;
    const userIndex = store.index("user_id");

    // Get all records for the specific user
    const formConfigs = await userIndex.getAll(user_id);

    // Filter by reportType if provided
    const filteredConfigs = reportType
      ? formConfigs.filter(x => x?.reportType === reportType)
      : formConfigs;

    return filteredConfigs?.map(x => ({
      event_type: x?.eventType,
      value: `${x?.eventType}${x?.reportType ? `_${x?.reportType}` : ""}`,
    }));
  } catch (error) {
    console.error("Error getting formConfigurations from IndexedDB:", error);
    throw error;
  }
}

    async syncAndClearFormConfigs(user_id) {
        try {
            await this.initDB();

            // 👉 First transaction just to read user's form configs
            const tx1 = this.db.transaction("formConfigurations", "readonly");
            const store1 = tx1.store;
            const userIndex = store1.index('user_id');
            const formConfigs = await userIndex.getAll(user_id);
            await tx1.done;

            if (!formConfigs || formConfigs.length === 0) {
                console.log(`No formConfigurations to sync for user: ${user_id}.`);
                return;
            }

            // 1️⃣ Call API
            const response = await formCreationService.syncFormConfiguration(formConfigs);
            if (!response) throw new Error("Sync failed");

            // 👉 Second transaction to delete user's form configs
            const tx2 = this.db.transaction("formConfigurations", "readwrite");
            const store2 = tx2.store;

            for (let cfg of formConfigs) {
                if (cfg?.eventType && cfg?.user_id === user_id) {
                    const compositeKey = [cfg.user_id, cfg.eventType, cfg.reportType || null];
                    console.log("Deleting user:", cfg.user_id, "eventType:", cfg.eventType, "reportType:", cfg.reportType);
                    await store2.delete(compositeKey);
                }
            }
            await tx2.done;

            console.log(`Sync successful for user: ${user_id}, local IndexedDB records cleared.`);
        } catch (error) {
            console.error("Error syncing formConfigurations:", error);
        }
    }

    async getUnsyncedFormConfigurations(user_id) {
        await this.initDB();

        try {
            const tx = this.db.transaction(['formConfigurations'], 'readonly');
            const store = tx.objectStore('formConfigurations');

            // Get all unsynced records
            const unsyncedIndex = store.index('synced');
            const allUnsynced = await unsyncedIndex.getAll(false);

            // Filter by user_id
            const userUnsynced = allUnsynced.filter(config => config.user_id === user_id);

            return userUnsynced || [];
        } catch (error) {
            console.error('Error getting unsynced form configurations:', error);
            throw error;
        }
    }

    async getInspectionsByReportType(user_id, reportType, options = {}) {
        if (!this.db) await this.initDB();

        try {
            const tx = this.db.transaction('inspections', 'readonly');
            const inspectionStore = tx.objectStore('inspections');
            const userReportTypeIndex = inspectionStore.index('userReportType');

            // Get all inspections matching the user_id and reportType
            let inspections = await userReportTypeIndex.getAll([user_id, reportType]);
            await tx.done;

            // Sort by date (newest first)
            inspections.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));

            // Process options for image handling
            const {
                includeImages = true,
                limitImages = null,
                onlyFirstImage = false,
                limit = null,
                offset = 0
            } = options;

            // Apply pagination if specified
            if (limit || offset) {
                const startIndex = offset || 0;
                const endIndex = limit ? startIndex + limit : inspections.length;
                inspections = inspections.slice(startIndex, endIndex);
            }

            if (!includeImages) {
                // Remove image data to reduce memory usage
                return inspections.map(inspection => ({
                    ...inspection,
                    data: this.removeImagesFromData(inspection.data)
                }));
            }

            // Apply image limits if specified
            if (limitImages || onlyFirstImage) {
                return inspections.map(inspection => ({
                    ...inspection,
                    data: this.limitImagesInData(inspection.data, limitImages, onlyFirstImage)
                }));
            }

            return inspections;

        } catch (error) {
            console.error('Error getting inspections by reportType:', error);
            throw error;
        }
    }


    // Get all event types for a specific user
    async getUserEventTypes(user_id) {
        if (!this.db) await this.initDB();

        try {
            const tx = this.db.transaction('inspections', 'readonly');
            const inspectionStore = tx.objectStore('inspections');
            const userIndex = inspectionStore.index('user_id');

            const userInspections = await userIndex.getAll(user_id);
            await tx.done;

            const eventTypes = [...new Set(userInspections.map(inspection => inspection.eventType))];
            return eventTypes.filter(Boolean);
        } catch (error) {
            console.error('Error getting user event types:', error);
            throw error;
        }
    }

    // Get all report types for a specific user
    async getUserReportTypes(user_id) {
        if (!this.db) await this.initDB();

        try {
            const tx = this.db.transaction('inspections', 'readonly');
            const inspectionStore = tx.objectStore('inspections');
            const userIndex = inspectionStore.index('user_id');

            const userInspections = await userIndex.getAll(user_id);
            await tx.done;

            const reportTypes = [...new Set(userInspections.map(inspection => inspection.reportType))];
            return reportTypes.filter(Boolean);
        } catch (error) {
            console.error('Error getting user report types:', error);
            throw error;
        }
    }

    // Get all IMO numbers for a specific user
    async getUserImoNumbers(user_id) {
        if (!this.db) await this.initDB();

        try {
            const tx = this.db.transaction('inspections', 'readonly');
            const inspectionStore = tx.objectStore('inspections');
            const userIndex = inspectionStore.index('user_id');

            const userInspections = await userIndex.getAll(user_id);
            await tx.done;

            const imoNumbers = [...new Set(userInspections.map(inspection => inspection.imo_number))];
            return imoNumbers.filter(Boolean);
        } catch (error) {
            console.error('Error getting user IMO numbers:', error);
            throw error;
        }
    }

    // Get inspection statistics for a specific user
    async getUserInspectionStats(user_id) {
        if (!this.db) await this.initDB();

        try {
            const tx = this.db.transaction('inspections', 'readonly');
            const inspectionStore = tx.objectStore('inspections');
            const userIndex = inspectionStore.index('user_id');

            const userInspections = await userIndex.getAll(user_id);
            await tx.done;

            const stats = {
                totalInspections: userInspections.length,
                eventTypes: [...new Set(userInspections.map(i => i.eventType))].filter(Boolean),
                reportTypes: [...new Set(userInspections.map(i => i.reportType))].filter(Boolean),
                ships: [...new Set(userInspections.map(i => i.imo_number))].filter(Boolean),
                totalImages: userInspections.reduce((sum, i) => sum + (i.imageCount || 0), 0),
                dateRange: {
                    earliest: userInspections.length > 0 ? Math.min(...userInspections.map(i => new Date(i.dateTime).getTime())) : null,
                    latest: userInspections.length > 0 ? Math.max(...userInspections.map(i => new Date(i.dateTime).getTime())) : null
                }
            };

            // Convert timestamps back to readable dates
            if (stats.dateRange.earliest) {
                stats.dateRange.earliest = new Date(stats.dateRange.earliest).toISOString();
            }
            if (stats.dateRange.latest) {
                stats.dateRange.latest = new Date(stats.dateRange.latest).toISOString();
            }

            return stats;
        } catch (error) {
            console.error('Error getting user inspection stats:', error);
            throw error;
        }
    }

    //     Example usage:
    //     const inspections = await db.getInspectionsByReportType(userId, 'DAILY_REPORT');
    //     // With options
    //     const inspections = await db.getInspectionsByReportType(userId, 'WEEKLY_REPORT', {
    //         includeImages: false,        // Exclude images for performance
    //         limit: 10,                   // Limit to 10 results
    //         offset: 0,                   // Starting from first record
    //         onlyFirstImage: true         // Include only first image per inspection
    //     });

}

export default InspectionDB;